export default "__VITE_ASSET__pSSX78Rl__"